import { Row } from "@amzn/stencil-react-components/layout";
import { Label } from "@amzn/stencil-react-components/text";
import { Checkbox } from "@amzn/uxm-stencil-react-components/lib/src/stencil";
import { ListModel } from "lib/models/list-models";
import React, { FC, memo } from "react";

interface ListOptionProps {
  index: number;
  isInList: boolean;
  list: ListModel;
  taxonomyId: string;
  isProcessing: boolean;
  onToggle: (isInList: boolean, listId: string) => void;
  "data-cy"?: string;
}

const ListOptionComponent: FC<ListOptionProps> = ({
  index,
  isInList,
  list,
  taxonomyId,
  isProcessing,
  onToggle,
  "data-cy": dataCy,
}) => (
  <Row alignItems="center" gridGap="S200" flex={1} key={`${list.listId}-${taxonomyId}`} padding="S100" data-cy={dataCy}>
    <Checkbox
      touchpoint={index === 0 ? "bookmark-add-to-favorite" : "bookmark-add-to-list"}
      key={`List-checkbox-${index}`}
      disabled={isProcessing}
      value={list.name}
      checked={isInList}
      onChange={() => onToggle(isInList, list.listId)}
      data-cy={dataCy ? `${dataCy}-checkbox` : undefined}
    />
    <Label>{list.name}</Label>
  </Row>
);

export const ListOption = memo(ListOptionComponent);

ListOption.displayName = "ListOption";
